// extracted by mini-css-extract-plugin
module.exports = {"LangSwitcher":"styles_LangSwitcher__x12j1","icon":"styles_icon__U6o7J"};